import Masonry from 'masonry-layout'
import jQueryBridget from 'jquery-bridget'
import $ from 'jquery'

export default function UserCollection() {
    $('a.delete-coll-item').click(function (e) {
        e.preventDefault()
        $.ajax({
            method: 'DELETE',
            url: $(this).data('url'),
        })
        $(this).parent().parent().fadeOut()
    });
    jQueryBridget('masonry', Masonry, $)

    $('.collection-masonry').masonry({
        itemSelector: '.grid-item',
        gutter: 15,
        percentPosition: true,
    })
}



// WEBPACK FOOTER //
// ./app/Resources/assets/js/front/collection.jsx